import { GoalType } from "@ctypes";
import { Translations, i18n } from "@i18n";

export const goalTypeLabel: Record<GoalType, string> = {
  [GoalType.Education]: i18n.t(Translations.GoalTypeRouteEducationLabel),
  [GoalType.EmergencyFund]: i18n.t(Translations.GoalTypeRouteEmergencyFundLabel),
  [GoalType.GenerationalWealth]: i18n.t(Translations.GoalTypeRouteLongTermSavingsLabel),
  [GoalType.House]: i18n.t(Translations.GoalTypeRouteHomeLabel),
  [GoalType.NewCar]: i18n.t(Translations.GoalTypeRouteCarLabel),
  [GoalType.Retirement]: i18n.t(Translations.GoalTypeRouteRetirementLabel),
  [GoalType.Vacation]: i18n.t(Translations.GoalTypeRouteVacationLabel),
  [GoalType.Custom]: i18n.t(Translations.GoalTypeRouteCustomLabel),
  [GoalType.TrumpAccountSidecar]: i18n.t(Translations.GoalTypeRouteTrumpSidecarLabel),
  [GoalType.HighYieldSavings]: i18n.t(Translations.GoalTypeRouteHighYieldSavingsLabel),
};
